import { render, staticRenderFns } from "./mind-assignment-task.vue?vue&type=template&id=6d59c498&"
import script from "./mind-assignment-task.vue?vue&type=script&lang=js&"
export * from "./mind-assignment-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports